var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{attrs:{"id":"trip-info-itinerary-stop-name"}},[_vm._v(" "+_vm._s(_vm.title || _vm.addressPretty)+" ")]),(_vm.title)?_c('div',{staticClass:"position-relative line-height-1 margin-b-1",attrs:{"id":"trip-info-itinerary-stop-address"}},[_c('span',[_vm._v(_vm._s(_vm.addressPretty))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }